import React, { useState, useEffect, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import InfiniteScroll from "react-infinite-scroll-component";

import "./searchResult.scss";

import { FetchApi } from '../api/FetchApi';
import ContentWrapper from '../contentWrapper/ContentWrapper';
import Spinner from '../spinner/Spinner';
import MovieCard from '../movieCard/MovieCard';

function SearchResult() {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [pageNum, setPageNum] = useState(1);
    const { query } = useParams();

    // Initial Fetch Function (Inside useCallback to avoid dependency errors)
    const dataFetchOfSearchKey = useCallback(() => {
        setLoading(true);
        FetchApi(`/search/multi?query=${query}&page=1`)
            .then((res) => res.json())
            .then((res) => {
                setData(res);
                setPageNum(2);
                setLoading(false);
            })
            .catch(() => setLoading(false));
    }, [query]);

    // Next Page Fetch (For Infinite Scroll)
    const nextDataFetch = () => {
        FetchApi(`/search/multi?query=${query}&page=${pageNum}`)
            .then((res) => res.json())
            .then((res) => {
                if (data?.results) {
                    setData({
                        ...data,
                        results: [...data?.results, ...res?.results]
                    });
                } else {
                    setData(res);
                }
                setPageNum((prev) => prev + 1);
            });
    };

    // Trigger Initial Fetch whenever query changes
    useEffect(() => {
        setPageNum(1);
        dataFetchOfSearchKey();
    }, [query, dataFetchOfSearchKey]);

    return (
        <div className="searchResultsPage">
            {loading && <Spinner initial={true} />}
            {!loading && (
                <ContentWrapper>
                    {data?.results?.length > 0 ? (
                        <>
                            <div className="pageTitle">
                                {`Search ${data.total_results > 1 ? "results" : "result"} of '${query}'`}
                            </div>
                            <InfiniteScroll
                                dataLength={data?.results?.length || 0}
                                className='content'
                                next={nextDataFetch}
                                hasMore={pageNum <= data?.total_pages}
                                loader={<Spinner />}
                            >
                                {data?.results?.map((item, index) => {
                                    if (item.media_type === "person") return null;
                                    return (
                                        <MovieCard 
                                            key={item.id || index} 
                                            data={item} 
                                            fromSearch={true} 
                                            mediaType={item.media_type} 
                                        />
                                    );
                                })}
                            </InfiniteScroll>
                        </>
                    ) : (
                        <span className="resultNotFound">
                            Sorry, Results not found!
                        </span>
                    )}
                </ContentWrapper>
            )}
        </div>
    );
}

export default SearchResult;